// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, PropsWithChildren } from "react";
import styled from "styled-components";

const TableWrapper = styled.div`
    ${spacingStyles()}
    overflow-x: auto;
`;

const Table = styled.table`
    border-spacing: 0;
    border-collapse: collapse;
    border: 1px solid ${getColor("common.border")};
`;

export const StyleguideTableBody = styled.tbody``;

export const StyleguideRow = styled.tr``;

export const StyleguideCell = styled.td`
    padding: 10px;
    text-align: left;
    vertical-align: middle;
    border-width: 1px;
    border-color: ${getColor("common.border")};
    border-style: solid;
`;

export const StyleguideHead = styled(StyleguideCell)`
    font-weight: bold;
`;

export const StyleguideCellInvert = styled(StyleguideCell)`
    color: ${getColor("invert")};
    background-color: ${getColor("primary")};
`;

export const StyleguideTable: FC<PropsWithChildren> = ({ children }) => (
    <TableWrapper>
        <Table>{children}</Table>
    </TableWrapper>
);
